import type { ReactNode } from "react";

/**
 * A figure, inline in prose.
 *
 * docs/design.md splits the two faces semantically: "If a value came from the
 * database, it is mono. If it is language written for a human, it is grotesk."
 * A wiki page is mostly language with numbers threaded through it, so the
 * split has to be per-word rather than per-block. This is the only way a
 * number reaches a wiki page, which makes the rule mechanical instead of
 * something eighteen topics each have to remember.
 */
export function Datum({ children }: { children: ReactNode }) {
  return <span className="font-data tabular-nums">{children}</span>;
}
